/* eslint complexity: ["error", 7] */
import * as PropTypes from 'prop-types';
import { BRANDS, Box, CheckCircledIconTwoTone, Curve, ProgressBar, THEME_CONSTANTS } from '@cof/plastic-components';
import { useBrand } from '../../BrandContext';
import { isAggregatorConsumer, isHosted } from '../../utilities/utils';
import { useAggregatorConsumerName } from '../../utilities/aggregatorConsumerNameProvider';

import styled, { keyframes } from 'styled-components';
import cssSystem from '@styled-system/css';

const { COLORS } = THEME_CONSTANTS;

const popIn = () => keyframes`
    from {
        opacity: 0;
        transform: translateY(-1rem)
    }
    to {
        opacity: 1;
        transform: translateY(0)
    }
`;

const AnimatedProgressBar = styled(ProgressBar)`
    animation: ${popIn()} 0.2s linear;
    position: relative;
    ${cssSystem({ bottom: ['-5px', '-6px', '-7px', '-9px', '-12px'] })}
    z-index: 99;
`;

const AnimatedBox = styled(Box)`
    animation: ${popIn()} 0.2s linear;
    max-width: 67.4rem;
    margin: auto;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;
`;

const ProgressBarSinglePage = ({ currentStageIndex, stages, progressBarVisible }: any) => {
    const brand = useBrand();
    // @ts-expect-error TS2488: Type '' must have a '[Symbol.iterator]()' method that returns an iterator.
    const [aggregatorConsumerName] = useAggregatorConsumerName();
    const isSimpleHeader = isHosted(brand) && !isAggregatorConsumer(aggregatorConsumerName);
    const backgroundColor = brand === BRANDS.CAPITAL_ONE ? COLORS.capitalOne.blue750 : COLORS.global.grey50;
    return (
        <>
            {isSimpleHeader ? (
                <AnimatedBox data-qa-id="progress-bar-single-page" display={progressBarVisible ? 'block' : 'none'}>
                    {/* @ts-expect-error TS2769: No overload matches this call. */}
                    <Box backgroundColor={backgroundColor}>
                        <AnimatedProgressBar
                            // @ts-expect-error TS2769: No overload matches this call.
                            p="xs"
                            mb="xs"
                            Icon={CheckCircledIconTwoTone}
                            steps={stages}
                            currentStep={currentStageIndex}
                            showEachStepText={false}
                            showStepCount={false}
                            backgroundColor={backgroundColor}
                            display={progressBarVisible ? 'block' : 'none'}
                        />
                    </Box>
                    <Curve
                        // comes with some non curve part at the top, so move that bit behind the progress bar
                        style={{ transform: 'translateY(-10px)' }}
                        border={false}
                        angle="shallow"
                        // @ts-expect-error TS2322: Type 'string' is not assignable to type 'ResponsiveColors'.
                        foregroundColor={backgroundColor}
                    />
                </AnimatedBox>
            ) : (
                <Box
                    position={'sticky'}
                    top={0}
                    left={0}
                    right={0}
                    zIndex="9"
                    data-qa-id="progress-bar-single-page"
                    display={progressBarVisible ? 'block' : 'none'}
                >
                    {/* @ts-expect-error TS2769: No overload matches this call. */}
                    <Box backgroundColor={backgroundColor}>
                        <ProgressBar
                            // @ts-expect-error TS2322: Type ' p: string; mb: string; Icon: (props: TwoToneIconProps) => Element; steps: any; currentStep: a
                            p="xs"
                            mb="xs"
                            Icon={CheckCircledIconTwoTone}
                            steps={stages}
                            currentStep={currentStageIndex}
                            showEachStepText={false}
                            showStepCount={false}
                            backgroundColor={backgroundColor}
                            display="block"
                        />
                    </Box>

                    <Curve
                        // comes with some non curve part at the top, so move that bit behind the progress bar
                        style={{ transform: 'translateY(-10px)' }}
                        border={false}
                        angle="shallow"
                        // @ts-expect-error TS2322: Type 'string' is not assignable to type 'ResponsiveColors'.
                        foregroundColor={backgroundColor}
                    />
                </Box>
            )}
        </>
    );
};

ProgressBarSinglePage.propTypes = {
    currentStageIndex: PropTypes.number.isRequired,
    stages: PropTypes.arrayOf(PropTypes.string).isRequired,
    progressBarVisible: PropTypes.bool
};

export default ProgressBarSinglePage;
